// Reco Pneus - Centralized Constants
// Edit these values in one place to update across the entire site

export const COMPANY = {
  name: "Reco Pneus",
  phone: "04 23 34 06 34",
  phoneLink: "tel:+33423340634",
  email: "recopneus@gmail.com",
  emailLink: "mailto:recopneus@gmail.com",
  hours: "7j/7 de 9h à 19h",
  coverageArea: "Alpes-Maritimes & Var",
  priorityZone: "Cannes / Mandelieu-la-Napoule",
  logo: "https://customer-assets.emergentagent.com/job_reco-pneus-preview/artifacts/xiti77mg_recopneus%20logo%20png.png",
};

export const SERVICES = [
  {
    id: "crevaison",
    title: "Dépannage crevaison à domicile",
    shortDesc: "Crevaison en urgence ? Nous intervenons directement chez vous ou sur la voie pour réparer ou remplacer votre pneu crevé. Service express disponible 7j/7.",
    icon: "Disc3",
    image: "https://customer-assets.emergentagent.com/job_reco-pneus-preview/artifacts/58arfpho_d%C3%A9pannage%20crevaison%20a%20domicile.png",
    slug: "depannage-crevaison-domicile-cannes",
    benefits: [
      "Intervention en moins de 45 minutes",
      "Réparation ou remplacement sur place",
      "Pneus de secours disponibles",
      "Service 7j/7"
    ],
    faq: [
      {
        question: "Combien de temps pour une intervention crevaison ?",
        answer: "Nous intervenons généralement en moins de 45 minutes dans notre zone prioritaire (Cannes, Mandelieu-la-Napoule). Pour les autres zones des Alpes-Maritimes et du Var, comptez 1h maximum."
      },
      {
        question: "Pouvez-vous réparer tous les types de crevaisons ?",
        answer: "Nous réparons la majorité des crevaisons. Si la réparation n'est pas possible (flanc endommagé, trou trop important), nous procédons au remplacement du pneu sur place."
      },
      {
        question: "Quel est le coût d'une intervention crevaison ?",
        answer: "Le tarif dépend de la nature de l'intervention (réparation ou remplacement) et de votre localisation. Contactez-nous pour un devis gratuit et immédiat."
      }
    ]
  },
  {
    id: "remplacement",
    title: "Remplacement pneumatiques express",
    shortDesc: "Besoin de changer vos pneus rapidement ? Rendez-vous garanti le jour même. Nous venons avec les pneumatiques adaptés à votre véhicule.",
    icon: "RefreshCw",
    image: "https://images.unsplash.com/photo-1620707044570-c0dc1576bedd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMGNoYW5naW5nJTIwY2FyJTIwdGlyZSUyMHdoZWVsJTIwc2VydmljZXxlbnwwfHx8fDE3NzUyMjMyMjB8MA&ixlib=rb-4.1.0&q=85",
    slug: "remplacement-pneus-express-alpes-maritimes",
    benefits: [
      "Rendez-vous le jour même",
      "Large choix de marques",
      "Montage et équilibrage inclus",
      "Prix compétitifs"
    ],
    faq: [
      {
        question: "Proposez-vous toutes les marques de pneus ?",
        answer: "Oui, nous travaillons avec toutes les grandes marques : Michelin, Continental, Bridgestone, Pirelli, Goodyear, et aussi des alternatives économiques de qualité."
      },
      {
        question: "Le montage est-il inclus dans le prix ?",
        answer: "Absolument ! Nos tarifs incluent la fourniture du pneu, le montage, l'équilibrage et la valve. Aucun frais caché."
      },
      {
        question: "Pouvez-vous intervenir le jour même ?",
        answer: "Oui, nous garantissons une intervention le jour même pour les demandes reçues avant 15h. Contactez-nous pour vérifier la disponibilité."
      }
    ]
  },
  {
    id: "ecrou-antivol",
    title: "Extraction écrou antivol",
    shortDesc: "Clé d'écrou antivol perdue ou endommagée ? Nous disposons de l'outillage professionnel pour extraire vos écrous sans endommager vos jantes.",
    icon: "Key",
    image: "https://images.unsplash.com/photo-1764015805414-df7de89d405b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHx0aXJlJTIwcmVwbGFjZW1lbnQlMjBtZWNoYW5pY3xlbnwwfHx8fDE3NzUyMjE5MjZ8MA&ixlib=rb-4.1.0&q=85",
    slug: "extraction-ecrou-antivol-var",
    benefits: [
      "Extraction sans dommage",
      "Outillage professionnel",
      "Toutes marques de véhicules",
      "Nouveaux écrous fournis"
    ],
    faq: [
      {
        question: "L'extraction abîme-t-elle les jantes ?",
        answer: "Non, notre outillage professionnel permet une extraction propre sans endommager vos jantes. Nous prenons toutes les précautions nécessaires."
      },
      {
        question: "Fournissez-vous de nouveaux écrous antivol ?",
        answer: "Oui, nous pouvons vous fournir et installer un nouveau jeu d'écrous antivol après l'extraction. Plusieurs modèles disponibles."
      },
      {
        question: "Intervenez-vous sur tous les véhicules ?",
        answer: "Oui, nous intervenons sur toutes les marques : voitures, utilitaires, SUV. Notre équipement couvre tous les types d'écrous antivol du marché."
      }
    ]
  },
  {
    id: "cle-perdue",
    title: "Dépannage clé de véhicule perdue",
    shortDesc: "Clé perdue, volée ou enfermée dans votre véhicule ? Intervention express sur place pour vous sortir de cette situation rapidement.",
    icon: "KeyRound",
    image: "https://images.unsplash.com/photo-1761014586544-53fe5e1f1e25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjYXIlMjBrZXklMjBoYW5kJTIwaXNvbGF0ZWR8ZW58MHx8fHwxNzc1MjIzMjIwfDA&ixlib=rb-4.1.0&q=85",
    slug: "depannage-cle-vehicule-perdue",
    benefits: [
      "Ouverture sans effraction",
      "Intervention rapide",
      "Véhicules toutes marques",
      "Solution immédiate"
    ],
    faq: [
      {
        question: "Pouvez-vous ouvrir ma voiture sans casser ?",
        answer: "Oui, nous utilisons des techniques et outils professionnels qui permettent l'ouverture sans aucun dommage à votre véhicule."
      },
      {
        question: "Intervenez-vous aussi la nuit ?",
        answer: "Nous intervenons de 9h à 19h, 7 jours sur 7. Pour les urgences en dehors de ces horaires, contactez-nous pour voir les possibilités."
      },
      {
        question: "Que faire si j'ai perdu ma seule clé ?",
        answer: "Nous pouvons ouvrir votre véhicule et vous conseiller sur les démarches pour obtenir une nouvelle clé auprès du concessionnaire ou d'un serrurier automobile."
      }
    ]
  },
  {
    id: "batterie",
    title: "Dépannage panne de batterie",
    shortDesc: "Batterie à plat ? Nous intervenons rapidement à domicile ou sur voie pour recharger ou remplacer votre batterie. Redémarrez en quelques minutes.",
    icon: "Battery",
    image: "https://images.unsplash.com/photo-1597766325363-f5576d851d6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjYXIlMjBiYXR0ZXJ5JTIwanVtcCUyMHN0YXJ0fGVufDB8fHx8MTc3NTIyMTkyNnww&ixlib=rb-4.1.0&q=85",
    slug: "depannage-panne-batterie",
    benefits: [
      "Diagnostic gratuit",
      "Recharge ou remplacement",
      "Batteries neuves disponibles",
      "Intervention rapide"
    ],
    faq: [
      {
        question: "Pouvez-vous recharger ma batterie sur place ?",
        answer: "Oui, nous disposons de boosters professionnels pour redémarrer votre véhicule immédiatement. Si la batterie est en fin de vie, nous pouvons la remplacer sur place."
      },
      {
        question: "Comment savoir si ma batterie doit être remplacée ?",
        answer: "Nous effectuons un diagnostic gratuit lors de l'intervention. Si la batterie est encore en bon état, une simple recharge suffira. Sinon, nous vous proposerons un remplacement."
      },
      {
        question: "Quelles marques de batteries proposez-vous ?",
        answer: "Nous proposons des batteries de grandes marques (Bosch, Varta, Exide) ainsi que des alternatives économiques de qualité, adaptées à votre véhicule."
      }
    ]
  },
  {
    id: "flottes",
    title: "Entretien flottes professionnelles",
    shortDesc: "Service dédié aux entreprises : entretien pneumatiques et mécanique directement sur votre site. Minimisez l'immobilisation de vos véhicules.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1587813369290-091c9d432daf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBmbGVldCUyMHZhbnMlMjB0cnVja3MlMjBtYWludGVuYW5jZSUyMHdvcmtzaG9wfGVufDB8fHx8MTc3NTIyMzg2MXww&ixlib=rb-4.1.0&q=85",
    slug: "entretien-flottes-professionnelles",
    benefits: [
      "Intervention sur site",
      "Contrats personnalisés",
      "Suivi de flotte",
      "Tarifs préférentiels"
    ],
    faq: [
      {
        question: "Intervenez-vous directement dans nos locaux ?",
        answer: "Oui, c'est notre spécialité ! Nous nous déplaçons sur votre site pour l'entretien de votre flotte, minimisant ainsi l'immobilisation de vos véhicules."
      },
      {
        question: "Proposez-vous des contrats d'entretien ?",
        answer: "Oui, nous proposons des contrats sur mesure adaptés à la taille de votre flotte et à vos besoins spécifiques, avec des tarifs préférentiels."
      },
      {
        question: "Quels types de véhicules prenez-vous en charge ?",
        answer: "Nous intervenons sur tous types de véhicules professionnels : voitures de société, utilitaires, camionnettes, véhicules de livraison, etc."
      }
    ]
  }
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Daphné G.",
    city: "Cannes",
    rating: 5,
    text: "Disponibilité très rapide, tarifs avantageux et service de proximité de qualité. 3 critères qui me feront revenir et pour lesquels je les recommande !",
  },
  {
    id: 2,
    name: "Norberto S.",
    city: "Grasse",
    rating: 5,
    text: "J'ai été très satisfait de l'accompagnement reçu. Tout s'est fait rapidement et de manière fluide, avec une vraie attention portée aux détails. On sent une vraie maîtrise du sujet et un sérieux qui met en confiance. C'est agréable d'avoir affaire à quelqu'un sur qui on peut compter du début à la fin. Je recommande.",
  },
  {
    id: 3,
    name: "Mathias C.",
    city: "Mandelieu",
    rating: 5,
    text: "Suite à un clou dans mon pneu, j'ai fait appelle à Reco pneu pour la réparation de derniere minute. C'est La seule personne qui a accepté la reparation aujourd'hui dans un rayon de 10km. Tres disponible, très efficace et sympathique, réparation réalisée en 10 min chrono. Je sais où retourner si la mésaventures recommence ! Encore merci",
  },
  {
    id: 4,
    name: "Amélie C.",
    city: "Mandelieu",
    rating: 5,
    text: "Un dépannage exceptionnel ! La rapidité et la qualité du service sont au rendez-vous. Un immense merci pour votre aide et votre rapidité. J'ai pu changer mon pneu en 1h15 top chrono et repartir. Je conseille à 100%",
  },
  {
    id: 5,
    name: "Christine C.",
    city: "Théoule sur Mer",
    rating: 5,
    text: "Enceinte, à terme, j'ai pris une vis dans le pneu..... J'ai appelé en expliquant que j'avais un besoin urgent de le faire réparer et 20 mn après mon appel, on me prenait en charge. Le patron a été très à l'écoute et le réparateur, très gentil et professionnel. Un grand merci à eux deux car je peux partir à la maternité quand le moment sera venu en toute sécurité. Je recommande.",
  },
  {
    id: 6,
    name: "Kylian H.",
    city: "Cannes",
    rating: 5,
    text: "Rapide efficace et très agréable ! Ils avez quatre pneus disponibles, neuf. Pneus montés équilibrés installé sur la voiture dans la journée, en plus il se déplace. Merci !",
  }
];

export const SEO = {
  home: {
    title: "Reco Pneus | Dépannage Pneu à Domicile Cannes, Alpes-Maritimes, Var",
    description: "Dépannage pneu à domicile 7j/7 dans les Alpes-Maritimes et le Var. Crevaison, remplacement pneus express, batterie, clé perdue. Intervention rapide Cannes, Nice, Antibes.",
    keywords: "dépannage pneu domicile, crevaison urgence, remplacement pneu express, Cannes, Alpes-Maritimes, Var, dépannage batterie, intervention rapide"
  }
};

export const CITIES = [
  "Cannes", "Mandelieu-la-Napoule", "Antibes", "Nice", "Grasse", 
  "Fréjus", "Draguignan", "Toulon", "Mougins", "Le Cannet",
  "Vallauris", "Valbonne", "Sophia Antipolis", "Saint-Raphaël"
];
